export default __webpack_public_path__ + "static/media/plantation_worker_clicked.f0820725.svg";